import ArticleTOC from './article-table-of-contents';

const articleTocConfig = {
  name: 'articleToc',
  class: ArticleTOC,
  querySelector: {},
  querySelectorAll: {
    links: '.article-table-of-contents__list li > a',
  },
  options: {
    activeClass: 'active',
  },
};

export default articleTocConfig;
